import { getInitials, seededPseudoRandom } from "../../../../helpers";

const getBackgroundColor = (seed: string): string => {
  const backgroundColors = [
    "#3ecf93", // primary background
    "#eb7070", // error background
    "#f6ad55", // warning background
    "#039aa6", // success background
    "#5597d3", // info background
    "#c86d9e", // help background
  ];
  const index = Math.floor(seededPseudoRandom(seed) * backgroundColors.length);
  return backgroundColors[index] ?? "#3ecf93";
};

const getTextColor = (themeName: string): string => {
  return themeName === "atlas-dark" ? "#1e2126" : "#ffffff";
};

export const createImageFromInitials = (
  size: number,
  name: string | null,
  themeName: string
): string | undefined => {
  if (name == null) return;
  const initials = getInitials(name);
  if (!initials) return;

  const backgroundColor = getBackgroundColor(name);
  const textColor = getTextColor(themeName);

  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  if (!context) return;

  canvas.width = canvas.height = size;

  context.fillStyle = "#ffffff";
  context.fillRect(0, 0, size, size);

  context.fillStyle = backgroundColor;
  context.fillRect(0, 0, size, size);

  context.fillStyle = textColor;
  context.textBaseline = "middle";
  context.textAlign = "center";
  context.font = `${size / 3.2}px Macan`;
  context.fillText(initials, size / 2, size / 2 + 20);

  return canvas.toDataURL();
};
